module.exports = __webpack_public_path__ + "static/media/awards_15.cad76a81.jpg";